export const enableInput = () => {
  const input = document.querySelector("#autoComplete");
  input.disabled = false;
};
